<template>
  <inertia-link :href="link">
    <div class="widget w-full p-4 rounded-lg bg-white border border-gray-100   shadow-md hover:shadow-lg
  hover:bg-gray-50">

      <div class="flex flex-row items-center justify-between">
        <div class="flex flex-col">
          <div class="text-sm  font-light text-gray-500">
            {{label}}
          </div>
          <div class="text-xl font-bold">
            {{value}}
          </div>
        </div>
        <i :class="icon"></i>
      </div>

    </div>
  </inertia-link>
</template>

<script>
export default {
  props: ['value', 'label', 'icon',
    'link']
}
</script>

<style>
</style>
